var _this = this;
import * as tslib_1 from "tslib";
import { MobileDeviceOption, initMobileDeviceFullOption } from 'owa-mobile-option';
var mobileSubCategory = {
    key: 'mobile',
    titleStringKey: 'optionSubcategory_mobile',
    options: [MobileDeviceOption],
    onSelected: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, initMobileDeviceFullOption()];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); },
};
export default mobileSubCategory;
//# sourceMappingURL=mobileSubCategory.js.map